import { Card, Flex, Spin } from "antd";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useReportEmbedUrl } from "../../../hooks/useReportEmbedUrl";
import ReportError from "./ReportError";

const ResidentDirectoryReport = observer(() => {

    const { reportUrl, isLoadReport, loadError } = useReportEmbedUrl("67");

    return <>
            <Flex vertical={true} gap={10}>
            <Link to="/BoardVue/Reports" style={{ marginLeft: 10 }}><ArrowLeftOutlined /> Back</Link>
                {/* <Card title={<Typography.Title level={5} style={{margin:0}}><b>Resident Directory</b></Typography.Title>}> */}
                    {/* <div id="BV_ResidentDirectory" className="reportIframe"></div> */}
                    {loadError
                        ? <ReportError message={loadError} />
                        : <iframe id="BV_ResidentDirectory" className="reportIframe"
                        src={reportUrl}
                        width="100%"
                        height="1000"
                        allowTransparency={true}
                        frameBorder={0}
                    ></iframe>}
                    {isLoadReport === true && !loadError ? <>
                        <Flex gap="small" vertical>
                            <Spin/>
                        </Flex>
                    </>: <></>}
                {/* </Card> */}
            </Flex>
    </>
})

export default ResidentDirectoryReport
